import React from 'react';

const LoaderMini = ({ className }) => {
    return (
        <div className={`mini-preloader ${className}`}>
            <div className="mini-preloader-content" />
        </div>
    );
};

export default LoaderMini;
